export default function StickyContact({ onOpenModal }) {
  return (
    <button
      onClick={() => onOpenModal()}
      data-testid="sticky-contact-button"
      className="fixed right-4 bottom-4 md:right-6 md:bottom-6 z-40 group"
    >
      {/* Desktop View - Vertical Layout */}
      <div className="hidden md:flex flex-col items-center">
        {/* Contact Us Text - Above Logo */}
        <div className="mb-2 bg-[#E12429] text-white px-4 py-2 rounded-full shadow-lg animate-pulse-scale">
          <span className="font-bold text-sm whitespace-nowrap tracking-wide">
            CONTACT US
          </span>
        </div>
        
        {/* Logo - Below Text */}
        <div className="bg-white p-3 rounded-full shadow-xl group-hover:shadow-2xl transition-all animate-float group-hover:scale-110">
          <img
            src="https://customer-assets.emergentagent.com/job_e8fbeb9b-6487-4b78-a6f7-665b46ef2f3a/artifacts/bk3s60pn_Circuit%207%20buloke%20logo%20%282%29.png"
            alt="The Circuit"
            className="w-14 h-14 object-contain"
          />
        </div>
      </div>

      {/* Mobile View - Compact Horizontal */}
      <div className="md:hidden flex items-center bg-[#E12429] text-white px-3 py-2 rounded-full shadow-lg animate-float">
        {/* Logo with white background circle */}
        <div className="bg-white rounded-full p-1.5 mr-2 flex items-center justify-center">
          <img
            src="https://customer-assets.emergentagent.com/job_e8fbeb9b-6487-4b78-a6f7-665b46ef2f3a/artifacts/bk3s60pn_Circuit%207%20buloke%20logo%20%282%29.png"
            alt="The Circuit"
            className="w-6 h-6 object-contain"
          />
        </div>
        <span className="font-semibold text-sm whitespace-nowrap">
          Contact
        </span>
      </div>
    </button>
  );
}